import React from "react";
import Chip from '@mui/material/Chip';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

const SettingsStatus = ({ settingsStatus }) => {
    return (
        <>
            {settingsStatus === true &&
                <div>
                    <Chip
                        icon={<CheckCircleOutlineOutlinedIcon style={{ color: '#2E7D32', fontSize: '16px' }} />}
                        label="Active"
                        size="small"
                        sx={{
                            backgroundColor: '#EDF7ED',
                            color: '#1E4620',
                            border: '1px solid #C2E0C6',
                            fontWeight: 700,
                            fontSize: '12px',
                            borderRadius: '8px',
                            px: 0.5,
                            height: '24px'
                        }}
                    />
                </div>
            }
            {settingsStatus === false &&
                <div>
                    <Chip
                        icon={<CancelOutlinedIcon style={{ color: '#D32F2F', fontSize: '16px' }} />}
                        label="Inactive"
                        size="small"
                        sx={{
                            backgroundColor: '#FEF2F2',
                            color: '#5F2120',
                            border: '1px solid #FDE2E2',
                            fontWeight: 700,
                            fontSize: '12px',
                            borderRadius: '8px',
                            px: 0.5,
                            height: '24px'
                        }}
                    />
                </div>
            }
        </>
    );
};

export default SettingsStatus;